class UsersApi {
    static putInterfaceSettings(field, value) {
        return axios.put('/api/user/interface_settings', {
            field: field,
            value: value
        })
            .then(response => response.data);
    }
}

export default UsersApi;
